import { inject } from '@angular/core';
import { 
  ActivatedRouteSnapshot, 
  Router, 
  CanActivateFn, 
} from '@angular/router';
import { UserService } from '../services/user_service';
import { User } from '../types/user';

export const userProfileAtGuard: CanActivateFn = (
  route: ActivatedRouteSnapshot
) => {
  const userService = inject(UserService);
  const router = inject(Router);
  
  const userName = route.paramMap.get('username');

  if (userName) {
    return userService.getUserProfileByUsername(userName).then((u: User) => {
      if (u && u.id) {
        return true;
      } else {
        router.navigate(['/']);
        return false;
      }
    })
    .catch(() => {
      router.navigate(['/']);
      return false; 
    });
  } else {
    return false; 
  }
};